import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardReservationsDataApi } from '../../../api/dashboard/adminGetDashboardReservationsDataApi';
import { AdminDashboardDataFilter, AdminDashboardReservationsDataResponse } from '../../../graphql/API';

export const useAdminGetDashboardReservationsDataQuery = (
  filter: AdminDashboardDataFilter,
  enabled = true,
): UseQueryResult<AdminDashboardReservationsDataResponse, Error> => {
  const adminGetDashboardQuery = useQuery({
    queryKey: ['admin-get-dashboard-reservations-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardReservationsDataApi({ ...filter });
      return response;
    },
    enabled:
      !!filter.fromDate ||
      !!filter.toDate ||
      !!filter.priorFromDate ||
      !!filter.priorToDate ||
      enabled,
  });

  return { ...adminGetDashboardQuery };
};
